export default __webpack_public_path__ + "static/media/close.5a3d7937.svg";